import { NavLink, useLocation } from "react-router-dom";
import { SELLER_FRAME_STEPS, sellerStepIndex } from "../../js/utils/sellerSteps";
import { toTitleCase } from "../../js/utils/titleCase";

export default function SellerNav() {
  const { pathname } = useLocation();
  const current = sellerStepIndex(pathname);

  const step = current >= 0 ? SELLER_FRAME_STEPS[current] : null;

  return (
    <nav className="seller-nav" aria-label="Seller portfolio steps" data-tour="seller-subnav">
      <p className="journey-step-meta">
        {step
          ? `Seller · ${current + 1} of ${SELLER_FRAME_STEPS.length} · ${toTitleCase(step.label)}`
          : "Seller Home"}
      </p>
      <ol className="seller-nav-list">
        {SELLER_FRAME_STEPS.map((step, index) => (
          <li key={step.path} data-tour={`seller-mark-${index}`}>
            <NavLink
              to={step.path}
              className={({ isActive }) =>
                `seller-step${isActive ? " is-active" : ""}${index < current ? " is-done" : ""}`
              }
            >
              {toTitleCase(step.label)}
            </NavLink>
          </li>
        ))}
      </ol>
    </nav>
  );
}
